export const HOSTED_FORM_ID = 'payment-form';
export const TRANSACTION_ID = 'TransactionId';
export const ACCOUNT_TOKEN = 'AccountToken';
export const HOSTED_PAYMENTS_RESPONSE = 'HostedPaymentsResponse';
export const AUTHENTICATION_KEY = 'AuthenticationKey';
export const HOSTED_FORM_SCRIPT_SOURCE = process.env.GATSBY_HOSTED_FORM_URL;
export const CARD_ENTRY_CONTEXT = 'WebConsumerInitiated';
export const HOSTED_FORM_OPERATION = 'Authorization';
export const HOSTED_FORM_TOKEN_OPERATION = 'Token';
export const PAYMENT_ACTION_TYPE = 'Pay_Validated_Amount';
export const FULLSTEAM_HOSTED_FORM_ID = 'fullsteam-hosted-card-data';
export const CARD_PROCESSOR_AUTH_KEY_AUTH_TYPE = 'Payment';
export const CARD_PROCESSOR_AUTH_KEY_TOKEN = 'Token';
export const CARD_PROCESSOR_TYPE = 'Syrapay';
export const CARD_PROCESSOR_SHOW_ON_PAYMENT = 'Payment';
export const CARD_PROCESSOR_STATUS = 'Active';
